import React, { useState, useEffect } from 'react';
import { profileData } from '../mock';
import './BootSequence.css';

const systemLogs = [
    '> Initializing Portfolio Shell OS...',
    '> Loading user profile data...',
    '> Connecting to GitHub repositories...',
    '> Fetching latest research papers...',
    '> Calibrating ML model accuracy...',
    '> Establishing secure connections...',
    '> Booting interactive terminal...',
    '> System ready. Welcome, Ibrahim!'
  ];

const BootSequence = ({ onComplete }) => {
  const [stage, setStage] = useState('loading'); // loading, card, transition
  const [progress, setProgress] = useState(0);
  const [logs, setLogs] = useState([]);

  // const systemLogs = [
  //   '> Initializing Portfolio Shell OS...',
  //   '> Loading user profile data...',
  //   '> Connecting to GitHub repositories...',
  //   '> Fetching latest research papers...',
  //   '> Calibrating ML model accuracy...',
  //   '> Establishing secure connections...',
  //   '> Booting interactive terminal...',
  //   '> System ready. Welcome, Ibrahim!'
  // ];

  useEffect(() => {
    // Progress bar animation
    const progressTimer = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(progressTimer);
          setTimeout(() => setStage('card'), 500);
          // setStage('card');
          return 100;
        }
        return prev + 2;
      });
    }, 80);

    // System logs animation
    const logTimer = setInterval(() => {
      setLogs(prev => {
        if (prev.length < systemLogs.length) {
          return [...prev, systemLogs[prev.length]];
        }
        clearInterval(logTimer);
        return prev;
      });
    }, 400);

    // Complete boot sequence
    const completeTimer = setTimeout(() => {
      setStage('transition');
      setTimeout(() => {
        onComplete();
      }, 1000);
    }, 3500);

    return () => {
      clearInterval(progressTimer);
      clearInterval(logTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div className={`boot-sequence ${stage}`}>
      <div className="boot-background">
        <div className="matrix-rain">
          {Array.from({ length: 20 }, (_, i) => (
            <div key={i} className="matrix-column" style={{ left: `${i * 5}%` }}>
              {Array.from({ length: 20 }, (_, j) => (
                <span key={j} className="matrix-char">
                  {String.fromCharCode(0x30A0 + Math.random() * 96)}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      {stage === 'loading' && (
        <div className="loading-screen">
          <div className="system-logs">
            {logs.map((log, index) => (
              <div key={index} className="log-line">
                {log}
              </div>
            ))}
          </div>
          <div className="loading-bar-container">
            <div className="loading-label">Booting Portfolio System...</div>
            <div className="loading-bar">
              <div 
                className="loading-progress" 
                style={{ width: `${progress}%` }}
              />
            </div>
            <div className="loading-percentage">{progress}%</div>
          </div>
        </div>
      )}

      {stage === 'card' && (
        <div className="id-card-container">
          <div className="id-card">
            <div className="card-glow" />
            <div className="card-content">
              <div className="card-header">
                <div className="security-badge">AUTHORIZED ACCESS</div>
                <div className="card-id">ID: #ML-2024-001</div>
              </div>
              
              <div className="card-main">
                <div className="photo-container">
                  <img 
                    src={profileData.photo} 
                    alt={profileData.name}
                    className="profile-photo"
                  />
                  <div className="photo-overlay" />
                </div>
                
                <div className="card-info">
                  <h2 className="card-name">{profileData.name}</h2>
                  <p className="card-tagline">{profileData.tagline}</p>
                  
                  <div className="card-stats">
                    <div className="stat">
                      <span className="stat-label">Status:</span>
                      <span className="stat-value">ACTIVE</span>
                    </div>
                    <div className="stat">
                      <span className="stat-label">Access Level:</span>
                      <span className="stat-value">FULL STACK</span>
                    </div>
                    <div className="stat">
                      <span className="stat-label">Clearance:</span>
                      <span className="stat-value">ML RESEARCH</span>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="card-footer">
                <div className="system-ready">
                  <span className="status-indicator" />
                  SYSTEM READY - ENTERING PORTFOLIO SHELL
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {stage === 'transition' && (
        <div className="transition-screen">
          <div className="shrinking-card">
            <div className="mini-card">
              <img src={profileData.photo} alt={profileData.name} />
              <div className="mini-info">
                <div className="mini-name">{profileData.name}</div>
                <div className="mini-status">ONLINE</div>
              </div>
            </div>
          </div>
          <div className="shell-booting">
            <div className="shell-prompt">
              <span className="prompt-text">ibrahim@portfolio:~$ _</span>
              <span className="cursor-blink" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BootSequence;